var _g, _g2, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _ellipse2, _path19, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSvgBelobank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 684.363,
    height: 509.972,
    viewBox: "0 0 684.363 509.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    transform: "translate(-137.819 -291.401)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_204",
    "data-name": "Ret\\xE2ngulo 204",
    width: 684.363,
    height: 0.342,
    transform: "translate(137.819 739.556)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_205",
    "data-name": "Ret\\xE2ngulo 205",
    width: 45.332,
    height: 0.342,
    transform: "translate(263.331 760.267)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_206",
    "data-name": "Ret\\xE2ngulo 206",
    width: 26.266,
    height: 0.342,
    transform: "translate(222.721 760.267)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_207",
    "data-name": "Ret\\xE2ngulo 207",
    width: 26.266,
    height: 0.342,
    transform: "translate(399.738 765.304)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_208",
    "data-name": "Ret\\xE2ngulo 208",
    width: 59.115,
    height: 0.342,
    transform: "translate(503.843 772.942)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_209",
    "data-name": "Ret\\xE2ngulo 209",
    width: 8.664,
    height: 0.342,
    transform: "translate(482.998 772.942)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_210",
    "data-name": "Ret\\xE2ngulo 210",
    width: 128.222,
    height: 0.342,
    transform: "translate(630.108 765.304)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_375",
    "data-name": "Caminho 375",
    d: "M462.207,678.506H197.919a7.814,7.814,0,0,1-7.8-7.816V299.149a7.815,7.815,0,0,1,7.8-7.748H462.207a7.815,7.815,0,0,1,7.815,7.816h0V670.69A7.815,7.815,0,0,1,462.207,678.506ZM197.919,291.675a7.472,7.472,0,0,0-7.459,7.474V670.69a7.472,7.472,0,0,0,7.459,7.474H462.207a7.487,7.487,0,0,0,7.473-7.474V299.149a7.487,7.487,0,0,0-7.473-7.474Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_376",
    "data-name": "Caminho 376",
    d: "M758.276,678.506h-264.3a7.829,7.829,0,0,1-7.816-7.816V299.149a7.83,7.83,0,0,1,7.816-7.748h264.3a7.816,7.816,0,0,1,7.788,7.748V670.69A7.816,7.816,0,0,1,758.276,678.506Zm-264.3-386.831a7.487,7.487,0,0,0-7.474,7.474V670.69a7.487,7.487,0,0,0,7.474,7.474h264.3a7.487,7.487,0,0,0,7.473-7.474V299.149a7.487,7.487,0,0,0-7.473-7.474Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_211",
    "data-name": "Ret\\xE2ngulo 211",
    width: 30.098,
    height: 119.403,
    transform: "translate(473.718 622.631)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_377",
    "data-name": "Caminho 377",
    d: "M498.095,742.034h5.721V725.772H492.1Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_212",
    "data-name": "Ret\\xE2ngulo 212",
    width: 30.098,
    height: 119.403,
    transform: "translate(341.827 622.631)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_213",
    "data-name": "Ret\\xE2ngulo 213",
    width: 136.873,
    height: 109.424,
    transform: "translate(366.943 622.631)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_378",
    "data-name": "Caminho 378",
    d: "M498.847,628.01v28.951H371.871V628.01H498.806m.534-.534H371.378v30.005h128V627.476Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_379",
    "data-name": "Caminho 379",
    d: "M372.651,742.034h-5.708V725.772h11.7Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_380",
    "data-name": "Caminho 380",
    d: "M432.355,642.479a3.024,3.024,0,1,0,3.025-3.025h0A3.025,3.025,0,0,0,432.355,642.479Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_381",
    "data-name": "Caminho 381",
    d: "M498.847,662.861v28.95H371.871v-28.95H498.806m.534-.52H371.378v30h128V662.354Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_382",
    "data-name": "Caminho 382",
    d: "M432.355,677.411a3.024,3.024,0,1,0,3.025-3.025h0A3.025,3.025,0,0,0,432.355,677.411Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_383",
    "data-name": "Caminho 383",
    d: "M498.847,697.725v28.964H371.871V697.725H498.806m.534-.534H371.378v30.018h128V697.191Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_384",
    "data-name": "Caminho 384",
    d: "M432.355,712.207a3.032,3.032,0,1,0,0-.014Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_214",
    "data-name": "Ret\\xE2ngulo 214",
    width: 30.098,
    height: 188.762,
    transform: "translate(323.445 553.286)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_385",
    "data-name": "Caminho 385",
    d: "M347.822,742.034h5.721V725.772h-11.7Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_215",
    "data-name": "Ret\\xE2ngulo 215",
    width: 30.098,
    height: 188.762,
    transform: "translate(210.963 553.286)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_216",
    "data-name": "Ret\\xE2ngulo 216",
    width: 117.478,
    height: 178.783,
    transform: "translate(236.066 553.286)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_386",
    "data-name": "Caminho 386",
    d: "M348.479,558.323V598.8H241.13V558.323H348.479m.63-.616H240.473v41.681H349.081V557.721Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_387",
    "data-name": "Caminho 387",
    d: "M348.479,603.741V711.1H297.344V603.741h51.135m.63-.63H296.728V711.728h52.381V603.111Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    "data-name": "Caminho 388",
    d: "M292.266,603.741V711.1H241.13V603.741h51.136m.615-.63H240.473V711.728h52.381V603.111Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    "data-name": "Caminho 389",
    d: "M241.787,742.034h-5.721V725.772h11.716Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_390",
    "data-name": "Caminho 390",
    d: "M291.773,578.582a3.039,3.039,0,1,0,3.052-3.025h-.014A3.038,3.038,0,0,0,291.773,578.582Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_391",
    "data-name": "Caminho 391",
    d: "M302.613,654.867a3.038,3.038,0,1,0,3.039-3.039h-.014a3.025,3.025,0,0,0-3.025,3.025Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_392",
    "data-name": "Caminho 392",
    d: "M280.946,654.867a3.032,3.032,0,1,0,0-.014Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_393",
    "data-name": "Caminho 393",
    d: "M277.524,500.654H264.836a133.964,133.964,0,0,1,2.2,18.644c0,6.844-9.663,33.988,4.106,33.988s4.106-27.076,4.106-33.988A134.179,134.179,0,0,1,277.524,500.654Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_394",
    "data-name": "Caminho 394",
    d: "M229.249,528.414v8.213a16.672,16.672,0,0,0,16.617,16.618h8.212a16.671,16.671,0,0,0,16.616-16.618v-8.213Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_395",
    "data-name": "Caminho 395",
    d: "M405.637,605.219c0,9.582,10.717,17.412,23.816,17.412h11.826c13.1,0,23.816-7.83,23.816-17.412Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_396",
    "data-name": "Caminho 396",
    d: "M718.993,591.175c-7.172,5.859-17.081,16.577-26.142,31.661-6.05,10.047-9.691,20.533-11.292,34.467,0-15.741.095-32.646.15-48.607,1.82-4.106,5.981-13.579,8.965-21.053,9.951-24.953,13.687-31.1,22.625-52.617,11.949-28.746,24.186-62.775,20.682-60.051-7.145,5.544-34.52,56.806-37.476,64.143a205.353,205.353,0,0,0-14.769,61.392c0-15.057.11-28.745.165-39.367.191-34.645.78-45.829,1.067-49.278,1.109-1.752,2.409-3.792,3.176-4.887,6.433-9.308,8.91-17.22,14.96-31.1,8.595-19.642,15.987-54.534,13.824-52.782-9.006,7.337-16.1,23.079-25.431,43.16s-6.666,31.619-8.513,48.757c-.384,3.368-.685,16.07-.9,33.66-2.409-18.753-6.953-31.1-15.234-42.324-10.183-13.812-20.038-23.134-27.265-28.007s12.483,29.047,21.9,43.8c8.39,13.2,16.124,24.817,20.531,36.274-.233,23.859-.342,54.055-.342,82.13-2.163-12.785-5.694-26.569-10.4-37.233C663.6,590.5,654.9,570.848,647.956,564.182c-1.656-1.6,7.254,36.63,12.976,46.786s9.923,19.752,13.523,25.515c.835,1.369,3.627,6.53,5.215,9.514,0,34.316.191,64.595.492,74.9h1.479c-.1-2.655-.124-20.122-.083-43.228,3.573-12.538,11.73-26.856,18.465-39.915C707.359,623.616,726.165,585.357,718.993,591.175Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_397",
    "data-name": "Caminho 397",
    d: "M702.336,742.034h-42.9l-3.244-42.05H705.58Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_398",
    "data-name": "Caminho 398",
    d: "M708.769,704.884H652.993l-1.588-14.195H710.37Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_217",
    "data-name": "Ret\\xE2ngulo 217",
    width: 76.717,
    height: 84.252,
    transform: "translate(231.179 319.462)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_218",
    "data-name": "Ret\\xE2ngulo 218",
    width: 79.249,
    height: 84.252,
    transform: "translate(236.955 319.462)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_219",
    "data-name": "Ret\\xE2ngulo 219",
    width: 65.973,
    height: 70.974,
    transform: "translate(243.594 326.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_220",
    "data-name": "Ret\\xE2ngulo 220",
    width: 33.985,
    height: 36.561,
    transform: "translate(259.58 343.293)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_221",
    "data-name": "Ret\\xE2ngulo 221",
    width: 71.27,
    height: 78.27,
    transform: "translate(627.795 329.277)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_222",
    "data-name": "Ret\\xE2ngulo 222",
    width: 73.61,
    height: 78.27,
    transform: "translate(633.174 329.277)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_223",
    "data-name": "Ret\\xE2ngulo 223",
    width: 61.278,
    height: 65.923,
    transform: "translate(639.347 335.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 19.122,
    cy: 19.122,
    r: 19.122,
    transform: "translate(650.857 349.29)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_224",
    "data-name": "Ret\\xE2ngulo 224",
    width: 56.912,
    height: 62.501,
    transform: "translate(330.686 369.698)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_225",
    "data-name": "Ret\\xE2ngulo 225",
    width: 58.787,
    height: 62.501,
    transform: "translate(334.97 369.698)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_226",
    "data-name": "Ret\\xE2ngulo 226",
    width: 48.932,
    height: 52.645,
    transform: "translate(339.897 374.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_399",
    "data-name": "Caminho 399",
    d: "M364.37,387.63l-13.386,23.188h26.772Z",
    fill: "#f5f5f5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-130"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 265.382,
    cy: 15.495,
    rx: 265.382,
    ry: 15.495,
    transform: "translate(214.618 770.382)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-130"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_227",
    "data-name": "Ret\\xE2ngulo 227",
    width: 8.746,
    height: 1.41,
    transform: "translate(464.246 312.714)",
    fill: "#0c4727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_228",
    "data-name": "Ret\\xE2ngulo 228",
    width: 23.516,
    height: 1.41,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 585.152, 392.009)",
    fill: "#0c4727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    "data-name": "Caminho 400",
    d: "M583.489,319.038H421.98L406.951,655.387h161.51Z",
    fill: "#af53ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    "data-name": "Caminho 401",
    d: "M578.671,323.664H417.162L402.133,660.013h161.51Z",
    fill: "#fafafa",
    opacity: 0.56,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    "data-name": "Caminho 402",
    d: "M573.854,328.277H412.344L397.3,664.626h161.51Z",
    fill: "#407bff",
    opacity: 0.07,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_403",
    "data-name": "Caminho 403",
    d: "M555.472,474.975H417.613l-1.15,25.734H554.322Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_404",
    "data-name": "Caminho 404",
    d: "M493.427,456.195H418.448l-.506,11.512h74.979Z",
    fill: "#af53ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_405",
    "data-name": "Caminho 405",
    d: "M552.365,544.429H414.506l-1.15,25.734H551.215Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    "data-name": "Caminho 406",
    d: "M527.084,604.918h-92.7L433,635.758h92.7Z",
    fill: "#af53ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    "data-name": "Caminho 407",
    d: "M520.884,640.549h-92.7a.256.256,0,0,1-.123,0,.185.185,0,0,1,0-.123l1.369-30.854a.149.149,0,0,1,.15-.151h92.718a.117.117,0,0,1,.109,0,.107.107,0,0,1,0,.109l-1.341,30.922A.179.179,0,0,1,520.884,640.549Zm-92.54-.329H520.72l1.368-30.525H429.713Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    "data-name": "Caminho 408",
    d: "M477.235,525.649H415.341l-.506,11.526h61.88Z",
    fill: "#af53ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    "data-name": "Caminho 409",
    d: "M525.318,391.846a36.309,36.309,0,0,1-7.623,20.6,36.79,36.79,0,0,1-29.017,14.468,33.275,33.275,0,0,1-33.527-33.021q-.008-1.025.048-2.048a36.957,36.957,0,0,1,36.613-35.07,33.248,33.248,0,0,1,33.555,32.938Q525.378,390.78,525.318,391.846Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_410",
    "data-name": "Caminho 410",
    d: "M528.617,364.113a9.576,9.576,0,0,1-2.026,5.476,9.81,9.81,0,0,1-7.719,3.846,8.869,8.869,0,0,1-7.364-3.846,9.047,9.047,0,0,1-1.533-5.476,9.829,9.829,0,0,1,9.732-9.308,8.843,8.843,0,0,1,8.922,8.762Q528.632,363.84,528.617,364.113Z",
    fill: "#af53ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_411",
    "data-name": "Caminho 411",
    d: "M432.464,487.842a4.365,4.365,0,0,1-4.311,4.106,3.9,3.9,0,0,1-3.947-3.854c0-.084,0-.168.005-.252a4.34,4.34,0,0,1,4.311-4.107,3.916,3.916,0,0,1,3.947,3.883C432.469,487.693,432.468,487.767,432.464,487.842Z",
    fill: "#af53ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_412",
    "data-name": "Caminho 412",
    d: "M450.915,487.842a4.353,4.353,0,0,1-4.312,4.106,3.9,3.9,0,0,1-3.933-3.868c0-.079,0-.159,0-.238a4.34,4.34,0,0,1,4.3-4.107,3.9,3.9,0,0,1,3.947,3.855C450.921,487.674,450.919,487.758,450.915,487.842Z",
    fill: "#af53ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_413",
    "data-name": "Caminho 413",
    d: "M469.379,487.842a4.353,4.353,0,0,1-4.312,4.106,3.913,3.913,0,0,1-3.946-3.882c0-.075,0-.149,0-.224a4.353,4.353,0,0,1,4.312-4.107,3.9,3.9,0,0,1,3.947,3.855C469.385,487.674,469.383,487.758,469.379,487.842Z",
    fill: "#af53ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_414",
    "data-name": "Caminho 414",
    d: "M429.357,557.3a4.366,4.366,0,0,1-4.311,4.107,3.915,3.915,0,0,1-3.947-3.883c0-.074,0-.149.005-.224a4.352,4.352,0,0,1,4.311-4.106,3.915,3.915,0,0,1,3.947,3.883C429.362,557.147,429.361,557.222,429.357,557.3Z",
    fill: "#af53ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    "data-name": "Caminho 415",
    d: "M447.808,557.3a4.354,4.354,0,0,1-4.3,4.107,3.9,3.9,0,0,1-3.947-3.854c0-.085,0-.169.005-.253a4.352,4.352,0,0,1,4.311-4.106,3.9,3.9,0,0,1,3.934,3.868C447.814,557.138,447.812,557.217,447.808,557.3Z",
    fill: "#af53ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_416",
    "data-name": "Caminho 416",
    d: "M466.313,557.3A4.353,4.353,0,0,1,462,561.4a3.929,3.929,0,0,1-3.946-3.911c0-.065,0-.13,0-.2a4.368,4.368,0,0,1,4.312-4.106,3.9,3.9,0,0,1,3.947,3.854C466.319,557.128,466.317,557.212,466.313,557.3Z",
    fill: "#af53ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_417",
    "data-name": "Caminho 417",
    d: "M484.736,557.3a4.367,4.367,0,0,1-4.312,4.107,3.929,3.929,0,0,1-3.946-3.911c0-.065,0-.13,0-.2a4.368,4.368,0,0,1,4.312-4.106,3.914,3.914,0,0,1,3.946,3.883C484.741,557.147,484.739,557.222,484.736,557.3Z",
    fill: "#af53ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_418",
    "data-name": "Caminho 418",
    d: "M503.268,557.3a4.366,4.366,0,0,1-4.311,4.107,3.9,3.9,0,0,1-3.947-3.854c0-.085,0-.169.005-.253a4.352,4.352,0,0,1,4.311-4.106,3.915,3.915,0,0,1,3.947,3.883C503.274,557.147,503.272,557.222,503.268,557.3Z",
    fill: "#af53ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 14.509,
    cy: 13.866,
    rx: 14.509,
    ry: 13.866,
    transform: "matrix(0.714, -0.7, 0.7, 0.714, 470.705, 380.353)",
    fill: "#407bff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_419",
    "data-name": "Caminho 419",
    d: "M517.7,412.447a36.79,36.79,0,0,1-29.017,14.468,33.217,33.217,0,0,1-27.7-14.468c6.652-6.625,17.177-10.951,28.839-10.951S511.631,405.822,517.7,412.447Z",
    fill: "#407bff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 14.509,
    cy: 13.866,
    rx: 14.509,
    ry: 13.866,
    transform: "matrix(0.714, -0.7, 0.7, 0.714, 470.705, 380.353)",
    fill: "#20242b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_420",
    "data-name": "Caminho 420",
    d: "M517.7,412.447a36.79,36.79,0,0,1-29.017,14.468,33.217,33.217,0,0,1-27.7-14.468c6.652-6.625,17.177-10.951,28.839-10.951S511.631,405.822,517.7,412.447Z",
    fill: "#20242b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_421",
    "data-name": "Caminho 421",
    d: "M316.314,506.91c-1.3,2.847-2.669,5.982-3.86,9.02s-2.409,6.174-3.463,9.295a118.215,118.215,0,0,0-4.9,18.89l-.3,2.012a2.958,2.958,0,0,0,.1,1.026,10.668,10.668,0,0,0,1.506,3.176,40.024,40.024,0,0,0,6.077,6.844,92.178,92.178,0,0,0,7.555,6.311c2.628,2.025,5.393,4,8.117,5.858l-2.56,4.8a96.967,96.967,0,0,1-18.409-10.554,44.336,44.336,0,0,1-8.213-7.775,19.5,19.5,0,0,1-3.271-5.845,13.287,13.287,0,0,1-.657-4.106v-1.711l.137-1.369a107.072,107.072,0,0,1,4.476-21c1.067-3.367,2.2-6.721,3.5-9.992s2.641-6.475,4.3-9.8Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M325.211,568.493l9.677-4.9-2.505,10.622s-6.638,1.862-9.718-1.369Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M343.743,565.331l-2.573,8.788-8.787.1,2.5-10.622Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M357.4,455.661a27.4,27.4,0,0,0,2.149,5.475,2.23,2.23,0,0,1-2.176.7Z",
    fill: "#e5b39c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_21",
    "data-name": "Elipse 21",
    cx: 1.027,
    cy: 1.574,
    rx: 1.027,
    ry: 1.574,
    transform: "translate(356.089 452.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M356.815,452.649l2.08-.588S357.882,453.676,356.815,452.649Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M330.672,465.708c1.246,6.365,2.491,18.041-1.971,22.3,0,0,1.752,6.461,13.591,6.461,13.017,0,6.214-6.461,6.214-6.461-7.1-1.7-6.925-6.967-5.68-11.922Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M327.209,451.2c.657,10.636.712,15.153,6.077,20.615,8.089,8.213,21.01,5.092,23.542-5.475,2.286-9.582.835-25.351-9.581-29.581A14.536,14.536,0,0,0,327.209,451.2Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    "data-name": "Caminho 428",
    d: "M328.263,439.235c-5.338,1.944-12.455.493-9.663,16.96,2.956,17.439-1.588,23.174-1.588,23.174s20.244,4.312,40.911-.26c0,0-6.309-11.033-4.544-19.164,2.259-10.266.479-14.058.479-14.058S335.764,436.5,328.263,439.235Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    "data-name": "Caminho 429",
    d: "M350.847,456.742a10.7,10.7,0,0,0,1.67,5.708c1.451,2.218,3.162,1.369,3.586-.985.383-2.067.1-5.722-1.752-7.146S350.874,454.292,350.847,456.742Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    "data-name": "Caminho 430",
    d: "M323.623,441.028c-1.533-4.312,5.776-10.951,21.243-8.213S361,448.433,361,448.433l-3.121-3.723.137,3.915-15.891,3.052Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    "data-name": "Caminho 431",
    d: "M324.937,488.732h0a2.423,2.423,0,0,1,1.985-2.738c4.818-.794,15.767-2.409,21.27-1.643,4.106.575,5.173,2.957,5.351,4.915a2.408,2.408,0,0,1-2.2,2.6,2.378,2.378,0,0,1-.327,0L327.223,490.8A2.438,2.438,0,0,1,324.937,488.732Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    "data-name": "Caminho 432",
    d: "M324.937,488.732h0a2.423,2.423,0,0,1,1.985-2.738c4.818-.794,15.767-2.409,21.27-1.643,4.106.575,5.173,2.957,5.351,4.915a2.408,2.408,0,0,1-2.2,2.6,2.378,2.378,0,0,1-.327,0L327.223,490.8A2.438,2.438,0,0,1,324.937,488.732Z",
    fill: "#952eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    "data-name": "Caminho 433",
    d: "M338.693,727.866,347.521,734l14.769-20.026-8.828-6.119Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M318.107,727.469l9.321,5.311L340.5,711.6l-9.321-5.311Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M362.276,713.973l-7.61,10.321-8.828-6.119,7.61-10.321Z",
    fill: "#e5b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    "data-name": "Caminho 436",
    d: "M331.165,706.294l9.335,5.325-6.734,10.91-9.335-5.325Z",
    fill: "#e5b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    "data-name": "Caminho 437",
    d: "M346.139,555.585s34.464,43.433,27.99,84.977c-5.215,33.55-35.464,78.982-35.464,78.982l-14.221-7.063a464.339,464.339,0,0,0,25.6-62.2,45.983,45.983,0,0,0-5.474-39.833c-17.465-25.5-45.442-10.321-26.622-54.863Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    "data-name": "Caminho 438",
    d: "M346.139,555.585s34.464,43.433,27.99,84.977c-5.215,33.55-35.464,78.982-35.464,78.982l-14.221-7.063a464.339,464.339,0,0,0,25.6-62.2,45.983,45.983,0,0,0-5.474-39.833c-17.465-25.5-45.442-10.321-26.622-54.863Z",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    "data-name": "Caminho 439",
    d: "M363.042,583.482l-5.009-4.982c0,.4,9.7,60.31,12.428,77.147a102.1,102.1,0,0,0,3.682-15.057C377.346,620.208,370.652,599.388,363.042,583.482Z",
    fill: "#ccb9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    "data-name": "Caminho 440",
    d: "M361.523,555.585s41.5,54.589,42.677,87.318c.972,27.377-45.168,80.419-45.168,80.419l-13.414-8.678s27-37.671,33.808-68.442c-2.628-30.5-58.2-90.617-58.2-90.617Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    "data-name": "Caminho 441",
    d: "M361.523,555.585s41.5,54.589,42.677,87.318c.972,27.377-45.168,80.419-45.168,80.419l-13.414-8.678s27-37.671,33.808-68.442c-2.628-30.5-58.2-90.617-58.2-90.617Z",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    "data-name": "Caminho 442",
    d: "M310.182,490.443c-4.434,1.054-8.691,17.179-8.691,17.179l17.342,11.58s5.776-12.758,3.75-18.342C320.489,495.042,315.753,489.115,310.182,490.443Z",
    fill: "#af53ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    "data-name": "Caminho 443",
    d: "M313.577,500.832l-1.2,14.058,6.447,4.326a57.765,57.765,0,0,0,3.928-12.512Z",
    fill: "#952eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    "data-name": "Caminho 444",
    d: "M366.656,490.758s5.119,1.793-5.133,64.814H317.915c.74-17.8.753-28.746-7.733-65.129a128.992,128.992,0,0,1,18.519-2.437,138.394,138.394,0,0,1,19.806,0C357.02,488.786,366.656,490.758,366.656,490.758Z",
    fill: "#af53ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_445",
    "data-name": "Caminho 445",
    d: "M371.09,500.832c.986,2.738,2.026,5.681,3.121,8.514s2.135,5.749,3.244,8.624l3.353,8.6.849,2.149.438,1.068.2.534v.082a2.821,2.821,0,0,0-.958-.849,3.907,3.907,0,0,0-1.779-.534,3.569,3.569,0,0,0-1.519.288c-.63.287-.63.411-.616.4a1.664,1.664,0,0,0,.3-.315,18.71,18.71,0,0,0,1.957-3.189c.643-1.26,1.259-2.6,1.875-3.956,1.2-2.738,2.313-5.571,3.422-8.432s2.163-5.749,3.189-8.665l3.121-8.733,5.269,1.369c-1.04,6.242-2.381,12.319-4,18.506-.78,3.08-1.7,6.133-2.738,9.213-.52,1.546-1.1,3.079-1.752,4.654a29.478,29.478,0,0,1-2.518,4.9,12.745,12.745,0,0,1-1.205,1.478,7.41,7.41,0,0,1-2.491,1.766,6.123,6.123,0,0,1-2.655.493,6.018,6.018,0,0,1-2.888-.863,7.357,7.357,0,0,1-2.491-2.587c-.205-.355-.383-.711-.507-.971l-.26-.521-.52-1.067-1.04-2.122c-1.369-2.847-2.737-5.722-3.928-8.61s-2.45-5.817-3.627-8.76-2.231-5.886-3.23-9.062Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    "data-name": "Caminho 446",
    d: "M366.656,490.758C371.9,492,377.8,507.5,377.8,507.5l-15.59,13.264s-10.087-16.891-8.048-22.462C356.281,492.5,359.812,489.129,366.656,490.758Z",
    fill: "#af53ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    "data-name": "Caminho 447",
    d: "M393.77,491.51l5.475-4.571,3.8,5.927-2.806,4.941s-4.462,4.107-8.4,2.012h0A7.08,7.08,0,0,1,393.77,491.51Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_448",
    "data-name": "Caminho 448",
    d: "M409.127,486.952l-.411,1.492-8.664,1.451-.849-2.957Z",
    fill: "#efc3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_449",
    "data-name": "Caminho 449",
    d: "M360.1,724.02l-15.631-10.1,2.806-4.873,17.561,10.8Z",
    fill: "#ccb9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    "data-name": "Caminho 450",
    d: "M333.546,732.069a9.416,9.416,0,0,1-3.859-1.369.246.246,0,0,1-.152-.314.243.243,0,0,1,.152-.151c.424-.137,4.106-1.273,5.173-.4a.873.873,0,0,1,.3.835,1.448,1.448,0,0,1-.78,1.177A1.791,1.791,0,0,1,333.546,732.069Zm-3.079-1.506c1.711.876,3.079,1.191,3.736.862a.956.956,0,0,0,.493-.794c0-.219,0-.314-.123-.369-.575-.466-2.628-.11-4.134.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_451",
    "data-name": "Caminho 451",
    d: "M329.782,730.8a.274.274,0,0,1-.191-.082.258.258,0,0,1,0-.247c0-.123.889-3.093,2.285-3.764a1.368,1.368,0,0,1,1.137,0,.9.9,0,0,1,.629.917c-.1,1.232-2.6,2.929-3.75,3.217Zm2.656-3.737a.934.934,0,0,0-.384.1c-.848.41-1.546,2.012-1.888,2.984,1.2-.507,2.86-1.848,2.915-2.6,0-.123,0-.274-.315-.411a1,1,0,0,0-.328-.109Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_452",
    "data-name": "Caminho 452",
    d: "M353.078,737.982c-1.547,0-3.7-1.985-4.873-3.2a.248.248,0,0,1,0-.287.286.286,0,0,1,.26-.137c.548,0,5.3.711,5.968,2.053a.779.779,0,0,1,0,.794,1.368,1.368,0,0,1-1.081.766Zm-3.969-3.011c1.724,1.67,3.244,2.6,4.106,2.491a.931.931,0,0,0,.712-.507.288.288,0,0,0,0-.314c-.356-.74-2.888-1.369-4.818-1.67Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_453",
    "data-name": "Caminho 453",
    d: "M349.259,734.9a4.473,4.473,0,0,1-.917-.068.244.244,0,0,1-.191-.151.284.284,0,0,1,0-.26c.082-.1,1.93-2.327,3.682-2.477a1.9,1.9,0,0,1,1.368.438c.534.465.507.876.37,1.136C353.229,734.451,350.861,734.9,349.259,734.9Zm-.356-.506c1.533.082,3.983-.425,4.3-1.095,0,0,.11-.219-.246-.52a1.37,1.37,0,0,0-1.04-.329,6,6,0,0,0-3.012,1.957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_454",
    "data-name": "Caminho 454",
    d: "M330.152,729.317l-11.607-3.285a.848.848,0,0,0-1.026.479l-3.915,8.8a1.724,1.724,0,0,0,.946,2.248,1.577,1.577,0,0,0,.19.065c4.106,1.068,6.077,1.369,11.183,2.834,3.148.876,7.637,2.505,11.976,3.737s5.79-3,4.106-3.9c-7.61-4.024-8.212-6.844-10.293-9.855A2.822,2.822,0,0,0,330.152,729.317Z",
    fill: "#af53ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_455",
    "data-name": "Caminho 455",
    d: "M348.52,733.177l-9.909-6.844a.85.85,0,0,0-1.123.11l-6.57,7.063a1.711,1.711,0,0,0,.159,2.415,1.564,1.564,0,0,0,.17.131c3.49,2.341,5.3,3.285,9.663,6.31,2.738,1.862,8.034,6,11.73,8.569s6.447-.958,5.133-2.354c-5.886-6.283-7.172-10.225-8.144-13.8A2.841,2.841,0,0,0,348.52,733.177Z",
    fill: "#af53ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_456",
    "data-name": "Caminho 456",
    d: "M340.486,720.447l-17.862-8.884,1.848-4.846,19.08,9.363Z",
    fill: "#ccb9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_457",
    "data-name": "Caminho 457",
    d: "M317.258,553.012l-1.505,3.942c-.151.3.205.616.712.616h45.277c.4,0,.726-.191.753-.438l.383-3.915c0-.26-.315-.492-.739-.492H317.97A.833.833,0,0,0,317.258,553.012Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_458",
    "data-name": "Caminho 458",
    d: "M317.258,553.012l-1.505,3.942c-.151.3.205.616.712.616h45.277c.4,0,.726-.191.753-.438l.383-3.915c0-.26-.315-.492-.739-.492H317.97A.833.833,0,0,0,317.258,553.012Z",
    fill: "#ccb9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_459",
    "data-name": "Caminho 459",
    d: "M324.39,557.953H323.2c-.233,0-.411-.123-.4-.273l.561-5.079c0-.137.219-.26.452-.26h1.19c.233,0,.411.123.4.26l-.561,5.079C324.828,557.83,324.622,557.953,324.39,557.953Z",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_460",
    "data-name": "Caminho 460",
    d: "M352.312,557.953h-1.178c-.232,0-.41-.123-.4-.273l.547-5.079c0-.137.233-.26.465-.26h1.177c.233,0,.425.123.4.26l-.547,5.079A.479.479,0,0,1,352.312,557.953Z",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 36.668,
    cy: 2.656,
    rx: 36.668,
    ry: 2.656,
    transform: "translate(286.681 784.454)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_461",
    "data-name": "Caminho 461",
    d: "M345.687,783.359c-6.488-1.889-13.687-4.312-18.04-6.844-.123-.082-.26-.124-.383-.192V746.948H340.39a3.915,3.915,0,0,0,0-7.816H327.332v-133.9h-7.884v133.9H306.4a3.915,3.915,0,1,0-.462,7.816,3.968,3.968,0,0,0,.462,0h13.044v29.334c-.123,0-.246.109-.369.192-4.421,2.573-11.566,5-18.054,6.844a1.916,1.916,0,0,0,.534,3.75h43.594a1.916,1.916,0,0,0,.534-3.709Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_229",
    "data-name": "Ret\\xE2ngulo 229",
    d: "M7.091,0H55.762a7.09,7.09,0,0,1,7.09,7.09V21.559a7.091,7.091,0,0,1-7.091,7.091H7.09A7.09,7.09,0,0,1,0,21.56V7.091A7.091,7.091,0,0,1,7.091,0Z",
    transform: "translate(291.937 591.599)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_462",
    "data-name": "Caminho 462",
    d: "M298.575,620.263v2.491c0,2.053,2.231,3.723,4.969,3.723h39.693c2.737,0,4.968-1.67,4.968-3.723v-2.491Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_463",
    "data-name": "Caminho 463",
    d: "M298.575,620.263v2.491c0,2.053,2.231,3.723,4.969,3.723h39.693c2.737,0,4.968-1.67,4.968-3.723v-2.491Z",
    fill: "#20242b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvgBelobank);
export default __webpack_public_path__ + "static/media/loginSvgBelobank.8ab93b765911c0562c429934a80e8e11.svg";
export { ForwardRef as ReactComponent };